import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import './component.scss';
import RfidRowBuilder from './rfid_row_builder';
import { baseRowManagementController as useBaseRowManagementController } from '../row_management';

application.register('batch-upload-rfid-row-management', class extends Controller {
  static targets = ['dataContainer']
  static values = {
    csvColumns: Array,
    noDataMessage: {type: String, default: 'Não há dados carregados' }
  }

  connect(){
    useBaseRowManagementController(this, new RfidRowBuilder(this.csvColumnsValue), {
      dataContainerTargetName: 'dataContainer',
      columnsValueName: 'csvColumns',
      noDataValueName: 'noDataMessage'
    });
  }
});
